import React from "react"
import Container from "../../atoms/Container"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import "./KlantLogos.css"

export default function KlantLogos({ block }) {
  console.log(block)
  return (
    <Container>
      <div className="vt-whitespace-container-120"></div>
      <div className="vt-logos-container">
        {block.logo.map(logo => {
          const image = getImage(
            logo.logo.localFile.childImageSharp.gatsbyImageData
          )
          return (
            <GatsbyImage
              className="vt-logo"
              imgStyle={{ objectFit: "contain" }}
              image={image}
            />
          )
        })}
      </div>
      <div className="vt-whitespace-container-120"></div>
    </Container>
  )
}
